import { render } from "./Provision.vue?vue&type=template&id=72b79f66"
import script from "./Provision.vue?vue&type=script&lang=js"
export * from "./Provision.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__